var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-14 f-medium c-pink-deep",domProps:{"innerHTML":_vm._s(_vm.matchResult(_vm.match))}})}
var staticRenderFns = []

export { render, staticRenderFns }